<template>
  <div class="policy">
    <common-layout>
      <div slot="header">
        <div class="policy_tabs">
          <span
              v-for="btn in tabs"
              :key="btn.id"
              :class="{ active_t: activeName == btn.id }"
              @click="handleClick(btn.id)"
          >{{ btn.name }}</span
          >
        </div>
        <ul class="policey_nav">
          <li>内容管理</li>
          <li class="active-Tab">政策服务</li>
        </ul>
      </div>
      <div slot="container">
        <div class="policy-search">
          <el-button
              icon="el-icon-plus"
              style="background: #623aa2; border: none"
              type="success"
              @click="add"
          >新增
          </el-button
          >
          <el-button icon="el-icon-delete" type="danger" @click="deleteAll"
          >批量删除
          </el-button
          >
          <el-input
              v-model="searchValue"
              class="input-with-select"
              clearable
              placeholder="请输入标题内容"
              @clear="search"
              @keyup.enter.native="search"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
            ></el-button>
          </el-input>
        </div>
        <div id="table">
          <!--动态绑定长宽-->
          <el-table
              ref="multipleTable"
              :data="tableData"
              :header-cell-style="headerStyle"
              style="width: 100%"
              type="index"
              @selection-change="tabSelect"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
                align="center"
                label="序号"
                type="index"
                width="150"
            >
              <template slot-scope="scope">
                <span>{{
                    scope.$index + (currentPage - 1) * per_page + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="标题"
                prop="name"
            ></el-table-column>
            <el-table-column
                align="center"
                label="时间"
                prop="dateTime"
            ></el-table-column>
            <el-table-column
                align="center"
                label="是否发布"
                prop="status"
                width="100"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.isPublish === 1" type="success"
                >已发布
                </el-tag
                >
                <el-tag v-else type="info">未发布</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <!-- <el-button-group> -->
                <el-button size="mini" @click="handleEdit(scope.row)"
                >编辑
                </el-button
                >
                <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.row)"
                >删除
                </el-button
                >
                <el-button
                    v-if="scope.row.isPublish === 2"
                    size="mini"
                    type="primary"
                    @click="preview(scope.row)"
                >确定发布
                </el-button
                >
                <el-button
                    v-else
                    size="mini"
                    type="warning"
                    @click="preview(scope.row)"
                >取消发布
                </el-button
                >
                <!-- </el-button-group> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            :current-page.sync="currentPage"
            :page-size="per_page"
            :total="total"
            layout="total, prev, pager, next, jumper"
            style="text-align: left; margin: 20px 0"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
        :close-on-click-modal="false"
        :title="Title"
        :visible.sync="dialogFormVisible"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
          label-width="105px"
      >
        <el-form-item label="标题" prop="name">
          <el-input v-model="ruleForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="viceName">
          <el-input v-model="ruleForm.viceName" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="dateTime">
          <el-date-picker
              v-model="ruleForm.dateTime"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
              style="text-align: left; width: 100%"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属年度" prop="year">
          <el-date-picker
              v-model="ruleForm.year"
              :picker-options="pickerOptions"
              format="yyyy"
              placeholder="选择年度"
              style="text-align: left; width: 100%"
              type="year"
              value-format="yyyy"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-col :span="16"> -->
        <el-form-item label="上传附件" style="text-align: center">
          <el-upload
              :action="this.uploadURL"
              :file-list="fileList"
              :on-preview="onPreview"
              :on-remove="onRemove"
              :on-success="handlePictureCardPreview"
              :show-file-list="true"
              accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
              class="upload-demo"
              name="file"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <!-- </el-col> -->
        <el-form-item prop="content">
          <!-- <editor :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          <editor
              v-model="ruleForm.content"
              :img-show-url="imgUrl"
              :upload-url="uploadURL"
          ></editor>
        </el-form-item>
        <el-form-item label="发布:" prop="isPublish" style="text-align: left">
          <el-col :span="12">
            <el-switch
                v-model="ruleForm.isPublish"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                active-text="是"
                inactive-color="#ff4949"
                inactive-text="否"
            ></el-switch>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-button type="primary" @click="submitForm('ruleForm')"
            >提交
            </el-button
            >
            <el-button @click="closeForm('ruleForm')">取消</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import editor from "../../../components/tinymce-editor/tinymce-editor";
// import editor from "../../../components/yhQuillEditor";
import CommonLayout from "../../../components/common-layout.vue";
import {DisabledDateFn, FunDownload, GetUrlName} from "../../../utils/tool";

export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      fileList: [],
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      show: false,
      tabs: [
        {
          id: 2,
          name: "国家政策",
        },
        {
          id: 1,
          name: "地方政策",
        },
      ],
      type: "",
      activeName: 2,
      selected: "",
      searchValue: "",
      total: 10,
      per_page: 10,
      currentPage: 1,
      dialogFormVisible: false,
      Title: "",
      tableData: [],
      ruleForm: {
        name: "",
        dateTime: "",
        // category_second: "",
        content: "",
        isPublish: 2,
        year: "",
        viceName: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        dateTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        year: [
          {
            required: true,
            message: "请选择年度",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
        // viceName: [{
        // 	required: true,
        // 	message: "请输入副标题",
        // 	trigger: "blur"
        // }],
      },
    };
  },
  created() {
    this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/small-policy/page`, {
      page: this.currentPage,
      isLocal: this.activeName
    });
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData(url, data) {
      this.http.post(url, data).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.currentPage = res.data.current_page;
        } else {
          this.$message.error("获取数据失败！！");
        }
      });
    },
    //新增
    add() {
      this.Title = "新建";
      this.dialogFormVisible = true;
      this.ruleForm = {
        name: "",
        dateTime: "",
        // category_second: "",
        content: "",
        isPublish: 2,
        year: "",
        viceName: "",
      };
      this.fileList = [];
    },
    //编辑
    handleEdit(val) {
      this.Title = "编辑";
      this.dialogFormVisible = true;
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/small-policy/get?id=${val.id}`).then((res) => {
        if (res.code === 0) {
          this.ruleForm = JSON.parse(JSON.stringify(res.data));
          this.fileList = this.ruleForm.file
              .split(",")
              .map((el) => {
                return {
                  name: GetUrlName(el),
                  url: el,
                };
              })
              .filter((d) => d.url);
        }
      });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.ruleForm.file = this.fileList
              .map((el) => {
                return el.url;
              })
              .join(",");
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          obj.isLocal = this.activeName;
          if (!obj.id) {
            // obj = await this.DeleteObject(obj);
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/small-policy/create`, obj).then((res) => {
              if (res.code === 0) {
                this.ResetSearch(["searchValue"]);

                this.$message.success("新建成功");
                this.search();
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            });
          } else {
            // obj = await this.DeleteObject(obj);

            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/small-policy/update`, obj).then((res) => {
              if (res.code === 0) {
                this.ResetSearch(["searchValue"]);
                this.$message.success("编辑成功");
                this.search();
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    handlePictureCardPreview(response, file, fileList) {
      this.fileList = this.getList(fileList);
    },
    getList(fileList) {
      return fileList.map((el) => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid,
        };
      });
    },
    onRemove(file, fileList) {
      this.fileList = this.getList(fileList);
    },
    onPreview(file) {
      FunDownload(this.imgUrl + file.url, file.name);
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //发布
    preview(e) {
      if (e.isPublish === 1) {
        e.isPublish = 2;
      } else if (e.isPublish === 2) {
        e.isPublish = 1;
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/small-policy/update`, e).then((res) => {
        if (res.code === 0) {
          e.isPublish === 1 ? this.$message.success("发布成功") : this.$message.warning("已取消发布");
          this.search();
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //搜索
    search() {
      this.getData(
          `${urlConfig.devUrl}apij2/admin-api/trade/small-policy/page`,
          {
            isLocal: this.activeName,
            keyword: this.searchValue
          }
      );
    },
    //删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.http.delete(`${urlConfig.devUrl}apij2/admin-api/trade/small-policy/delete?id=${row.id}`).then((res) => {
              if (res.code === 0) {
                this.ResetSearch(["searchValue"]);

                this.search();
                this.searchValue = "";
                this.type = "";
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    //批量删除
    deleteAll() {
      if (this.selected) {
        this.$confirm("确定删除文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              this.http.delete(`${urlConfig.devUrl}apij2/admin-api/trade/small-policy/deleteAll?ids=${this.selected}`)
                  .then((response) => {
                    this.ResetSearch(["searchValue"]);

                    if (response.code === 0) {
                      this.$message.success("删除成功！");
                      this.search();
                      this.searchValue = "";
                      this.type = "";
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的文件",
        });
      }
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.content = val;
    },
    //翻页
    handleCurrentChange(val) {
      this.getDate(
          `${urlConfig.devUrl}apij2/admin-api/trade/small-policy/page`,
          {
            isLocal: this.activeName,
            keyword: this.searchValue,
            page: val
          }
      );
    },
    //选择行数
    tabSelect(sec) {
      let ids = "";
      for (let i of sec) {
        ids += i.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    // 切换tab
    handleClick(val) {
      this.activeName = val;
      this.searchValue = "";
      this.type = "";
      this.search()
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  height: 100%;

  .policy-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .selectType {
      display: inline-block;
    }
  }

  .policy_tabs {
    width: 300px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }

  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: "/";
        }
      }
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }

  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
</style>
